<template>
  <div>
    <footer class="footer footer-main" id="footer">
      <div class="footer__join footer__area">
        <div class="footer__join-content">
            <v-container>
              <v-layout row wrap justify-center class="text-center">
                <v-flex xs12 justify-center>
                  <div class="text-wrapper">
                    <h2 class="join-text">REJOINDRE LE BOP</h2>
                  </div>
                </v-flex>
                <v-flex>
                  <v-btn color="orange" class="text--light" :to="{name: 'inscription'}">inscriptions / Licences </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
        </div>
      </div>
      <div class="footer__top footer__area">
        <div class="container-fluid">
          <div class="row">
            <div class="footer-box col-md-3">
              <div class="footer-box__container">
                <h5 class="footer-box__title">A propos du BOP</h5>
                <ul>
                  <li><router-link :to="{name: 'club'}" href="#">Le Club</router-link></li>
                  <li><router-link :to="{name: 'actus'}" href="#">Les News</router-link></li>
                  <li><router-link :to="{name: 'agenda'}" href="#">L'Agenda</router-link></li>
                  <li>
                    <a id="activities" href="#activities">Les activités</a>
                    <ul>
                      <li><router-link :to="{name: 'equipes'}" href="#">Equipes CD13</router-link></li>
                      <li><router-link :to="{name: 'mini-basket'}" href="#">Mini-Basket</router-link></li>
                      <li><router-link :to="{name: 'obe'}" href="#">Opération Basket Ecole</router-link></li>
                      <li><router-link :to="{name: 'agenda'}" href="#">Animations Vacances</router-link></li>
                      <li><router-link :to="{name: 'sport-sante'}" href="#">Sport-Santé</router-link></li>
                    </ul>
                  </li>
                  <li>
                    <router-link :to="{name : 'inscription'}">Inscriptions / Licences</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'galeries'}" href="#">Les Galeries</router-link>
                  </li>
                  <li><router-link :to="{name: 'contact'}" href="#">Nous contacter</router-link></li>
                </ul>

                <ul>
                  <li><router-link :to="{name: 'sponsors'}" href="#"><span>Les Partenaires</span></router-link></li>
                  <li><router-link :to="{name: 'boutique'}" href="#"><span>La Boutique</span></router-link></li>
                </ul>
              </div>
            </div>

            <div class="footer-box col-md-3">
              <div class="footer-box__container">
                <h5 class="footer-box__title">Informations</h5>
                <ul>
                  <li><router-link :to="{name: 'mentions'}" href="#">Mentions légales</router-link></li>
                  <li><router-link :to="{name: 'rgpd'}" href="#">Politique de confidentialité</router-link></li>
                  <li><router-link :to="{name: 'cookies'}" href="#">Politique de cookies</router-link></li>
                  <li><router-link :to="{name: 'cgv'}" href="#">Conditions générales de vente</router-link></li>
                  <li><router-link :to="{name: 'plan'}" href="#">Plan du site</router-link></li>
                  <li><router-link :to="{name: 'contact'}" href="#">Contact</router-link></li>
                </ul>
              </div>
            </div>

            <div class="footer-box col-md-3">
              <div class="footer-box__container">
                <h5 class="footer-box__title">Nous contacter</h5>
                <ul>
                  <li>
                    <router-link :to="{name: 'contact'}" href="#">
                      <i class="fas fa-address-book"></i>Adresse
                    </router-link>
                    <router-link :to="{name: 'contact'}" href="#"><span class="footer-box__contact-info">380 Avenue du Stade<br>13610 Le Puy-Sainte-Réparade</span></router-link>

                  </li>
                  <li>
                    <router-link :to="{name: 'contact'}" href="#">
                      <i class="fas fa-at"></i>Email
                    </router-link>
                    <router-link :to="{name: 'contact'}" href="#"><span class="footer-box__contact-info">contact@bop-lepuy.fr</span></router-link>
                  </li>
                  <li v-if="false">
                    <router-link :to="{name: 'contact'}" href="#">
                      <i class="fas fa-phone"></i>Téléphone
                    </router-link>
                    <router-link :to="{name: 'contact'}" href="#"><span class="footer-box__contact-info">+33 (0)4 42 12 34 56</span></router-link>

                  </li>
                  <li>
                    <router-link :to="{name: 'contact'}" href="#"><i class="fas fa-map-marker-alt"></i>Accès</router-link>
                    <span class="footer-box__contact-info">
                      <a class="footer-box_maps-link" href="https://goo.gl/maps/GK2ZoLaEc9Q2" target="_blank">
                        <span class="footer-box_maps-position">43°39'38.6"N, 5°25'22.8"E</span>
                        <br>
                        <span class="footer-box_maps-position">43.660722, 5.423000</span>
                      </a>
                    </span>
                      <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d721.5991728746048!2d5.4224638292547125!3d43.66071899869506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDPCsDM5JzM4LjYiTiA1wrAyNScyMi44IkU!5e0!3m2!1sfr!2sfr!4v1540467930751"
                              width="auto" max-width="200%" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>  -->
                    </li>
                </ul>
              </div>
            </div>

            <div class="footer-box col-md-3">
              <div class="footer-box__container">
                <router-link tag="div" :to="{name: 'club'}" class="footer-logo_bop-wrapper">
                  <!--<img src="/static/assets/logo_final_blanc_nobg.png" alt="Logo Basket Olympique Puechen" class="footer-logo_bop">-->
                  <img src="/static/assets/FINAL_COULEUR_FOND_BLANC_Rond.png" alt="Logo Basket Olympique Puechen" class="footer-logo_bop">
                </router-link>
                <div class="footer-address">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- footer__top -->
      <div class="footer__copyright footer__area">
        <div class="copyright-box">
          <p>Copyright &copy; 2019 Basket Olympique Puechen 2019 | Tous droits réservés</p>
        </div>
        <div class="social-box">
          <a href="https://fb.me/BOP.BasketOlympiquePuechen" target="_blank"><i class="fab fa-facebook-f"></i></a>
          <!-- <a href="#footer"><i class="fas fa-rss"></i></a> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  }
};
</script>

<style lang="scss">
@import "./../../../scss/pages/shared/__footer-section.scss";
.footer {
  border-top: 5px solid orange;
}
.footer__join {
  $color-bg-dark: rgba(14,28,52, 1) ; // #0087b8;
  $color-percent-plus: 0%;

  background-color: darken($color-bg-dark, $color-percent-plus) ;
  // background-color: #333;
  color: #F2F3F3;
  padding: 20px 20px;
}
.footer__top {
    $color-bg-dark: rgba(14,28,52, 1); // #0087b8;
  $color-percent-plus: 4%;
  background-color: darken($color-bg-dark, $color-percent-plus) ;


}
.footer__area:nth-of-type(2n+1) {
  box-shadow: 1px 2px 5px rgba(#000, 1);
}

.footer-logo_bop-wrapper {
  position: relative;
  display: block;
  padding: 0 2rem;
  text-align: center;
  width: 100%;

  .footer-logo_bop {

    position: relative;
    display: inline-block;
    width: 99%;
    height: auto;
    opacity: 0.8;
    cursor: pointer;

  }
}

.footer {
  .social-box {

    i {
      position: relative;
      margin: 0 auto;
      font-size: 2rem;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/Footer.vue